import NoShipmentSvg from "@/src/assets/icons/icon-no-shipment.svg";
import Icon from "@/src/components/atom/Icon";
import Typo from "@/src/components/atom/Typo";
import Flex from "@/src/components/molecule/Flex";
import { HTMLAttributes } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

interface NoShipmentDataProps extends HTMLAttributes<HTMLDivElement> {
  iconSize?: number;
  height?: number;
}

function NoShipmentData({
  height = 110,
  iconSize = 52,
  ...rest
}: NoShipmentDataProps) {
  const { t } = useTranslation();

  return (
    <StyledFlex
      flexDirection="column"
      alignItems="center"
      height={height}
      {...rest}
    >
      <Icon iconSrc={NoShipmentSvg} iconSize={iconSize} />
      <Typo typoType="b7m" color="gray8">
        {t("common:noShipment")}
      </Typo>
    </StyledFlex>
  );
}

export default NoShipmentData;

const StyledFlex = styled(Flex)<{ height: number }>``;
